import { ALL_LEADS_CALL_LOGS } from "../../constant/ActionType";

export default function GetAllLeadsCallLogsReducer(
    state = {
        allleadcalllogs: [],
        statusCode: null,
    },
    action
) {
    switch (action.type) {
        case ALL_LEADS_CALL_LOGS:
            return {
                ...state,
                allleadcalllogs: action.data,
                statusCode: action.status,
            };

        default:
    }

    return state;
}
